import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  TbSquareLetterS,
  TbSquareLetterM,
  TbSquareLetterA,
} from 'react-icons/tb';

import { useTranslation } from '../../../common/hooks/useTranslation';

interface CustomEmailDataInfoProps {
  emailText: string | null | undefined;
  emailSubject: string | null | undefined;
  hasAttachments?: boolean;
}

export const CustomEmailDataInfo: React.FC<
  CustomEmailDataInfoProps
> = props => {
  const { t, tk } = useTranslation('fvsLng');
  return (
    <div className="ps-2 d-flex align-items-center gap-2">
      {props.emailText && (
        <OverlayTrigger
          overlay={<Tooltip>{t(tk.sendEmail.emailText)}</Tooltip>}
        >
          <TbSquareLetterM size={20} className="text-blue" />
        </OverlayTrigger>
      )}
      {props.emailSubject && (
        <OverlayTrigger
          overlay={<Tooltip>{t(tk.sendEmail.emailSubject)}</Tooltip>}
        >
          <TbSquareLetterS size={20} className="text-blue" />
        </OverlayTrigger>
      )}
      {props.hasAttachments && (
        <OverlayTrigger
          overlay={<Tooltip>{t(tk.sendEmail.attachments)}</Tooltip>}
        >
          <TbSquareLetterA size={20} className="text-blue" />
        </OverlayTrigger>
      )}
    </div>
  );
};
